require('./bootstrap');

import { createApp, h } from 'vue';
import store from './Store'
import { createInertiaApp } from '@inertiajs/vue3'
import VueSweetalert2 from "vue-sweetalert2";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
const { RayPlugin } = require('vue-ray');
const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import * as Sentry from "@sentry/vue";
const environment =
	document.querySelector('meta[name="environment"]').content ?? "production";
const App = createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: name => require(`./Pages/${name}`),
    setup({ el, App, props, plugin }) {
        const app =  createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(VueSweetalert2)
            // .use(RayPlugin, { interceptErrors: true, host: '127.0.0.1', port: 23517 })
            .use(store)
            .component('QuillEditor', QuillEditor)
            .component('v-select', vSelect)
            .mixin({ methods: { route,
                number_format(nStr) {
                    nStr += '';
                    let x = nStr.split('.');
                    let x1 = x[0];
                    let x2 = x.length > 1 ? '.' + x[1] : '';
                    let rgx = /(\d+)(\d{3})/;
                    while (rgx.test(x1)) {
                        x1 = x1.replace(rgx, '$1' + ',' + '$2');
                    }
                    return x1 + x2;
                },
                formatCurrency (value, currencyCode, showSymbol = false) {

                    const localFormat = {style: 'currency', currency: currencyCode, currencyDisplay: showSymbol === false ? 'code' : 'symbol'}
                    let result = Intl.NumberFormat('en-GB', localFormat).format(value)
                    if(showSymbol === false) {
                        result = result.replace(/[a-z]{3}/i, "").trim()
                    }
                    result = result.toLocaleString();
                    return result
                }
            },
        });

        Sentry.init({
            app,
            dsn: "https://f4b7909863e54556ce9dc0f05bc389c8@o4507378355404800.ingest.de.sentry.io/4508976128589904",
            tracesSampleRate: 0, // Disable performance monitoring
            environment: environment,
            integrations: [
                Sentry.browserTracingIntegration({
                    instrumentNavigation: false,
                    instrumentPageLoad: false,
                }),
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: false,
                }),
                Sentry.replayCanvasIntegration(),
                Sentry.thirdPartyErrorFilterIntegration({
                    filterKeys: ["jPuAGO7b0KnsS5iyyXsEytNSl9fmnENT"],
                    behaviour: "drop-error-if-contains-third-party-frames",
                }),
            ],
            replaysOnErrorSampleRate: 1.0, // Keep session replays for errors
            replaysSessionSampleRate: 0, // Disable regular session replays
        });

        return app.mount(el);
    },
    progress: {
        color: '#4B5563',
        includeCSS: true
    },
});
